module.exports = __webpack_public_path__ + "img/coral.5d81faef.png";